import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/core/request';

export type TranslationOverridesGridResponse = {
  languages: string[];
  allowedKeys: string[];
  base: Record<string, Record<string, string>>; // base[lang][key] = value
  overrides: Record<string, Record<string, string>>; // overrides[lang][key] = value
  orphans: Record<string, string[]>; // orphans[lang] = keys[]
};

@Injectable()
export class TranslationOverridesService {
  constructor(private request: RequestService) {}

  getAdminGrid(): Observable<TranslationOverridesGridResponse> {
    return this.request.get('/api/i18n-overrides/admin/grid');
  }

  upsert(lang: string, key: string, value: string): Observable<any> {
    return this.request.put('/api/i18n-overrides', { lang, key, value });
  }

  reset(lang: string, key: string): Observable<any> {
    return this.request.post('/api/i18n-overrides/reset', { lang, key });
  }

  importProperties(text: string): Observable<any> {
    return this.request.post('/api/i18n-overrides/admin/import-properties', { text });
  }
}

